import crud from '@/crud/index/index'

import data from './data'
import mounted from './mounted'
import components from './components'
import methods from './methods'
import computed from './computed'

export default {
  data,
  methods,
  mounted,
  components,
  computed,
  mixins: [crud]

}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/gadget/resources/index.js